import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { GetAllActiveDealerResponseModel, Preferences } from '../business-entities/preferences-model';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class PreferenceDataService {

  constructor(private dataProvider: DataService) {

  }

  async getPreferenceList(preferenceObj: any): Promise<GenericResponse<Array<Preferences>>> {
    return this.dataProvider.Post<GenericResponse<Array<Preferences>>>(Urls.GetPreferenceList, preferenceObj)
      .toPromise();
  }

  deletePreference(preferenceId: number) {
    return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeletePreference, preferenceId)
      .toPromise();
  }

  activeInactivePreference(preferenceObj: any): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ActiveInactivePreference, preferenceObj)
      .toPromise();
  }

  async getPreferenceById(preferenceId: number): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>
      (Urls.GetPreference, preferenceId).toPromise();
  }

  async addEditPreference(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditPreference, model).toPromise();
  }
  async activeInactiveDealer(model): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ActiveInActiveDealerForPreference, model)
      .toPromise();
  }
  getAllActiveDealer(): Promise<GenericResponse<Array<GetAllActiveDealerResponseModel>>>{
    return this.dataProvider.Get<GenericResponse<Array<GetAllActiveDealerResponseModel>>>(Urls.GetAllActiveDealerForPreference).toPromise();
}
}
